module.exports = __webpack_public_path__ + "vue_assets/img/img_timeline.f74ce828.webp";